/* eslint-disable global-require */
import 'core-js/features/global-this';
import { cs } from 'date-fns/locale';
import React, { type ReactNode } from 'react';

import { IntlProvider } from '@skippay/core/i18n/intl';
import { AppLanguage } from '@skippay/core/i18n/languages';
import { useLocaleContext } from '@skippay/core/providers/LocaleProvider/LocaleProvider';

export const DEFAULT_LOCALE = cs;

interface Props {
	children: ReactNode;
	ssrLanguageConfig?: {
		locale: AppLanguage;
		messages: Record<string, string>;
	};
}

function LocalizationProvider(props: Props): JSX.Element {
	const { ssrLanguageConfig, children } = props;

	const clientConfig = useLocaleContext();

	const locale = ssrLanguageConfig?.locale || clientConfig.locale || DEFAULT_LOCALE.code;
	const messages = ssrLanguageConfig?.messages || clientConfig.messages;

	return (
		<IntlProvider defaultLocale={locale} locale={locale} messages={messages}>
			{children}
		</IntlProvider>
	);
}

export default LocalizationProvider;
